<template>
  <div id="psot-card-top">
    <div class="container">
      <div class="avatar"><img class="user-img" :src="getUserInfo.HeadShot" alt="使用者" /></div>
      <div class="name">{{ getUserInfo.NickName }}</div>
      <q-btn class="post-btn" @click="createSharePost($route.name)" color="lale-primary" text-color="white" label="發佈" />
    </div>
    <!-- 外部模組 tiptap editor -->
    <editor-content class="editor" :editor="editor"></editor-content>
  </div>
</template>

<script>
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex';
import { Editor, EditorContent } from 'tiptap';
export default {
  name: 'SharePostTop',
  components: {
    EditorContent
  },
  data() {
    return {
      content: '',
      // initialize editor
      editor: new Editor({
        onUpdate: ({ getHTML }) => {
          this.content = getHTML();
        }
      })
    };
  },
  computed: {
    ...mapGetters(['getUserInfo'])
  },
  methods: {
    ...mapMutations('EditPostModule', ['SET_CONTENT']),
    ...mapActions('EditPostModule', ['createSharePost']),
  },
  watch: {
    content() {
      this.SET_CONTENT(this.content);
    }
  }
};
</script>

<style scoped lang="scss">
.ProseMirror {
  outline: none;
}
.q-pa-md {
  padding: 5vw 5vw 0 5vw;
}
.test {
  border: 1px solid rgba(0, 0, 0, 0.2);
}
.container {
  display: grid;
  grid-template-columns: 20vw auto 25vw;
  height: 70px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.2);
}
.avatar {
  margin-left: 5vw;
  margin-top: 4px;
  align-self: center;
}
.user-img {
  width: 50px;
  height: 50px;
  border-radius: 50%;
}
.name {
  justify-self: left;
  align-self: center;
  font-size: 15px;
  font-weight: bold;
}
.post-btn {
  min-width: 60px;
  align-self: center;
  margin: 0 5vw 0 auto;
}
.editor {
  width: 90vw;
  margin: 5vw auto 0 auto;
}
</style>

<style>
.ProseMirror {
  height: 20vh;
  width: 100%;
  padding: 12px 20px;
  margin: 8px 0;
  box-sizing: border-box;
  border: 1px solid rgba(0, 0, 0, 0.2);
  border-radius: 5px;
  transition: 0.5s;
  outline: none;
  overflow: auto;
}
.ProseMirror p {
  margin: 0;
  line-height: 1.2;
}
.ProseMirror-focused {
  border: 1px solid #26a69a;
}
</style>
